import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/clientRecommendations';

export default function ClientRecommendations() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Everything in exam section 2.3: client types and profiling, capital market theory, portfolio management, tax and retirement planning, estate planning, trading mechanics, and performance measurement."
      parts={parts}
    />
  );
}
